<template>
    <div id="moduleAppList">
        <div class="top">
            <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
        </div>
        <div>
            <el-table
                :height="windowHeight - 245"
                :data="dataList"
                style="width: 100%" border
            >
                <el-table-column
                    label="订单号"
                    align="center" show-overflow-tooltip
                    prop="orderId"
                >
                </el-table-column>
                <el-table-column
                    label="购买个数" show-overflow-tooltip
                    align="center"
                    prop="baseCount"
                >
                </el-table-column>
                <el-table-column
                    label="购买年数"
                    align="center" show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span>{{ scope.row.numberYears}}年</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="订单金额" show-overflow-tooltip
                    align="center"
                >
                    <template slot-scope="scope">
                        <span>{{ scope.row.price / 100}}元</span>
                    </template>
                </el-table-column>

                <el-table-column
                    label="订单状态" show-overflow-tooltip
                    align="center"
                >
                    <template slot-scope="scope">
                        {{['待支付', '已支付', '未支付', '订单已关闭', '订单已过期', '申请退款中', '退款成功', '退款被拒绝'][scope.row.orderStatus]}}
                    </template>
                </el-table-column>

                <el-table-column
                    label="支付时间" show-overflow-tooltip
                    align="center"
                >
                    <template slot-scope="scope">
                        <span>{{ scope.row.payTime}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="过期时间" show-overflow-tooltip
                    align="center"
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.expireTime}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="下单时间" show-overflow-tooltip
                    align="center"
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.orderCreateTime}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="下单人" show-overflow-tooltip
                    align="center"
                >
                    <template slot-scope="scope">
                        <span>{{scope.row.byerUserName}}</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import LocationSelector from '@/components/LocationSelector';

    import windowResize from '@/mixins/windowResize';
    import baseMixin from '@/mixins/baseMixin';
    import {
        listOrder
    } from '@/api/schoolManage';

    export default {
        name: 'newOrderList',
        data() {
            return {
                schoolId: this.$route.query.schoolId,
                stautus: 1,
                type: 0 ,
                dataList: []
            }
        },
        filters: {
            timeFormat(time) {
                return time ? time.substring(0, 19) : ''
            }
        },
        components: {LocationSelector},
        created() {
            this.getList();
        },
        mixins: [windowResize, baseMixin],
        methods: {
            getList() {
                listOrder({
                    schoolId: this.schoolId
                })
                    .then(data => {
                        this.dataList = data;
                    })
            },
        }
    }
</script>
<style>
    #moduleAppList .el-select {
        width: 120px;
    }
</style>
<style lang="scss" scoped>
    #moduleAppList {
        padding: 12px;

        .pagination-container {
            margin-top: 10px;
        }

        .top {
            padding-bottom: 10px;
            overflow: hidden;

        }

        a, .link {
            color: #409EFF;
            cursor: pointer;
        }

        .state-container {
            margin: 15px 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/schoolManage/newOrderList.vue